;(function () {
  var DRAWER_ID = "ComplementaryProductDrawer"
  var CONTENT_ID = "ComplementaryProductDrawerContent"
  var SECTION_ID = "complementary-product-drawer"
  var CLOSING_PANELS_CLASS = "complementary-drawer--closing-panels"
  var PANELS_PRIME_CLASS = "complementary-drawer--panels-prime"
  var STAGED_CLOSE_ATTR = "data-complementary-staged-close"
  var LOADING_CLASS = "complementary-drawer__content--loading"
  var PANELS_SELECTOR = ".complementary-drawer-product__panels"
  var ajaxCartCloseBound = false
  var stagedCloseGen = 0
  var stagedTimeouts = { fbClose: 0, fbInfo: 0 }
  var pendingComplementaryAjaxForm = null
  var fetchLoadGen = 0

  function flushPendingComplementaryAjaxProduct() {
    var form = pendingComplementaryAjaxForm
    pendingComplementaryAjaxForm = null
    if (!form || typeof form.dispatchEvent !== "function") return
    window.requestAnimationFrame(function () {
      form.dispatchEvent(new CustomEvent("ajaxProduct:added", { bubbles: true }))
    })
  }

  function clearComplementaryStagedTimeouts() {
    if (stagedTimeouts.fbClose) {
      window.clearTimeout(stagedTimeouts.fbClose)
      stagedTimeouts.fbClose = 0
    }
    if (stagedTimeouts.fbInfo) {
      window.clearTimeout(stagedTimeouts.fbInfo)
      stagedTimeouts.fbInfo = 0
    }
  }

  function getDrawerController() {
    return window.theme && window.theme._complementaryDrawerCtl
  }

  function getLoadErrorMessage() {
    var el = document.getElementById(DRAWER_ID)
    var msg = el && el.getAttribute("data-drawer-load-error")
    return msg && String(msg).trim()
      ? String(msg).trim()
      : "We couldn't load this product. Close the drawer and try again."
  }

  function showComplementaryLoadError(content) {
    if (!content) return
    content.classList.remove(LOADING_CLASS)
    content.innerHTML = ""
    var p = document.createElement("p")
    p.className = "complementary-drawer__error"
    p.setAttribute("role", "alert")
    p.textContent = getLoadErrorMessage()
    content.appendChild(p)
  }

  function buildFetchUrl(handle) {
    var base = (window.theme && theme.routes && theme.routes.home) || "/"
    var path = "/products/" + encodeURIComponent(handle) + "?section_id=" + SECTION_ID
    var url = base.replace(/\/$/, "") + path
    url = url.replace(/([^:])\/\//g, "$1/")
    return url
  }

  function removeProductInstance(contentEl) {
    var prev = contentEl.querySelector('.product-section[data-section-type="product"]')
    if (!prev || !window.theme || !theme.sections) return
    var sid = prev.getAttribute("data-section-id")
    if (sid && typeof theme.sections._removeInstance === "function") {
      theme.sections._removeInstance(sid)
    }
  }

  function setDrawerTitle(text) {
    document.querySelectorAll(".js-complementary-drawer-title").forEach(function (el) {
      if (el) el.textContent = text || ""
    })
  }

  function applyDescriptionVisibility(show) {
    var root = document.getElementById(CONTENT_ID)
    if (!root) return
    var desc = root.querySelector(".complementary-drawer__description")
    if (!desc) return
    if (show === false || show === "false") {
      desc.classList.add("hide")
      desc.setAttribute("hidden", "")
    } else {
      desc.classList.remove("hide")
      desc.removeAttribute("hidden")
    }
  }

  function parseTransitionDurationMs(el) {
    if (!el || !window.getComputedStyle) return 400
    var raw = window.getComputedStyle(el).transitionDuration.split(",")[0]
    raw = (raw && raw.trim()) || "0s"
    if (raw.indexOf("ms") !== -1) return parseFloat(raw) || 0
    return (parseFloat(raw) || 0) * 1000
  }

  function parseCssTimeMsFromRoot(root, prop, fallbackMs) {
    if (!root || !window.getComputedStyle) return fallbackMs
    var raw = window.getComputedStyle(root).getPropertyValue(prop).trim()
    if (!raw) return fallbackMs
    if (raw.indexOf("ms") !== -1) {
      var n = parseFloat(raw)
      return n >= 0 && !isNaN(n) ? n : fallbackMs
    }
    if (raw.indexOf("s") !== -1) {
      var sec = parseFloat(raw)
      return sec >= 0 && !isNaN(sec) ? sec * 1000 : fallbackMs
    }
    return fallbackMs
  }

  function installStagedClose(ctl, closeOrig) {
    ctl.closeImmediate = function () {
      if (!ctl.isOpen) return
      stagedCloseGen++
      clearComplementaryStagedTimeouts()
      var root = document.getElementById(DRAWER_ID)
      if (root) {
        root.classList.remove(CLOSING_PANELS_CLASS)
        root.removeAttribute(STAGED_CLOSE_ATTR)
      }
      closeOrig()
      flushPendingComplementaryAjaxProduct()
    }

    ctl.close = function (evt) {
      var root = document.getElementById(DRAWER_ID)
      if (!root || !ctl.isOpen) {
        if (root) root.classList.remove(CLOSING_PANELS_CLASS)
        pendingComplementaryAjaxForm = null
        return closeOrig()
      }

      if (root.getAttribute(STAGED_CLOSE_ATTR) === "1") {
        pendingComplementaryAjaxForm = null
        return
      }

      if (evt && evt.target && typeof evt.target.closest === "function") {
        var insideDrawer = evt.target.closest("#" + DRAWER_ID)
        var onClose = evt.target.closest(".js-drawer-close")
        var panelsEl = root.querySelector(PANELS_SELECTOR)
        var t = evt.target
        var onPanelsChrome =
          panelsEl &&
          t !== panelsEl &&
          typeof panelsEl.contains === "function" &&
          panelsEl.contains(t)
        if (insideDrawer && !onClose && onPanelsChrome) {
          return
        }
      }

      var mq = window.matchMedia("(min-width: 769px)")
      var hasProduct = root.classList.contains("complementary-drawer--has-content")

      if (!mq.matches || !hasProduct) {
        root.classList.remove(CLOSING_PANELS_CLASS)
        closeOrig()
        flushPendingComplementaryAjaxProduct()
        return
      }

      stagedCloseGen++
      var myGen = stagedCloseGen
      clearComplementaryStagedTimeouts()

      var mediaPanel = root.querySelector(".complementary-drawer-product__media-panel")
      var infoPanel = root.querySelector(".complementary-drawer-product__info-panel")
      var mediaDurCss = parseCssTimeMsFromRoot(root, "--comp-drawer-media-dur", 300)
      var fromComputed = mediaPanel ? parseTransitionDurationMs(mediaPanel) : 0
      var mediaMs = fromComputed >= 80 ? fromComputed : mediaDurCss
      var infoDurCss = parseCssTimeMsFromRoot(root, "--comp-drawer-dur", 250)
      var fromInfo = infoPanel ? parseTransitionDurationMs(infoPanel) : 0
      var infoMs = fromInfo >= 80 ? fromInfo : infoDurCss

      var finished = false
      var mediaPhaseDone = false

      function doneClosing() {
        if (myGen !== stagedCloseGen) return
        if (finished) return
        finished = true
        clearComplementaryStagedTimeouts()
        if (mediaPanel) mediaPanel.removeEventListener("transitionend", onMediaEnd, false)
        if (infoPanel) infoPanel.removeEventListener("transitionend", onInfoEnd, false)
        root.removeAttribute(STAGED_CLOSE_ATTR)
        closeOrig()
        root.classList.remove(CLOSING_PANELS_CLASS)
        flushPendingComplementaryAjaxProduct()
      }

      function afterMediaPhase() {
        if (myGen !== stagedCloseGen) return
        if (mediaPhaseDone) return
        mediaPhaseDone = true
        clearComplementaryStagedTimeouts()
        if (mediaPanel) mediaPanel.removeEventListener("transitionend", onMediaEnd, false)
        stagedTimeouts.fbInfo = window.setTimeout(doneClosing, infoMs + 200)
        if (infoPanel) {
          infoPanel.addEventListener("transitionend", onInfoEnd, false)
        }
      }

      function onMediaEnd(e) {
        if (myGen !== stagedCloseGen) return
        if (mediaPhaseDone) return
        if (e.propertyName !== "transform") return
        if (!mediaPanel || !mediaPanel.contains(e.target)) return
        afterMediaPhase()
      }

      function onInfoEnd(e) {
        if (myGen !== stagedCloseGen) return
        if (finished) return
        if (e.propertyName !== "transform") return
        if (!infoPanel || !infoPanel.contains(e.target)) return
        doneClosing()
      }

      root.setAttribute(STAGED_CLOSE_ATTR, "1")

      if (mediaPanel) {
        mediaPanel.addEventListener("transitionend", onMediaEnd, false)
      }

      stagedTimeouts.fbClose = window.setTimeout(function () {
        if (myGen !== stagedCloseGen) return
        afterMediaPhase()
      }, mediaMs + 120)

      window.requestAnimationFrame(function () {
        if (myGen !== stagedCloseGen) return
        root.classList.add(CLOSING_PANELS_CLASS)
      })
    }
  }

  function bindComplementaryBackdrop(drawerEl, ctl) {
    if (!drawerEl || !ctl || drawerEl.dataset.complementaryBackdropBound === "1") return
    drawerEl.dataset.complementaryBackdropBound = "1"
    var back = drawerEl.querySelector(".js-complementary-drawer-backdrop")
    if (!back) return
    back.addEventListener("click", function (e) {
      e.preventDefault()
      e.stopImmediatePropagation()
      if (ctl.isOpen && typeof ctl.close === "function") ctl.close()
    })
  }

  function bindComplementaryAjaxCloseThenCart() {
    if (ajaxCartCloseBound) return
    ajaxCartCloseBound = true
    window.addEventListener(
      "ajaxProduct:added",
      function (evt) {
        var t = evt.target
        if (!t || typeof t.closest !== "function") return
        if (!t.closest("#" + DRAWER_ID)) return
        if (window.theme && theme.settings && theme.settings.cartType === "page") return
        var ctl = getDrawerController()
        if (!ctl || !ctl.isOpen) return
        pendingComplementaryAjaxForm = t
        if (typeof evt.stopImmediatePropagation === "function") evt.stopImmediatePropagation()
        if (typeof evt.stopPropagation === "function") evt.stopPropagation()
        if (typeof ctl.close === "function") ctl.close()
      },
      true
    )
  }

  function initInjectedProduct(contentEl) {
    if (!window.theme || !theme.sections) return
    theme.sections.register("product", theme.Product, contentEl)
    if (typeof theme.collapsibles !== "undefined" && theme.collapsibles.init) {
      theme.collapsibles.init(contentEl)
    }
    if (typeof theme.videoModal === "function") {
      theme.videoModal()
    }
    if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === "function") {
      Shopify.PaymentButton.init()
    }
    if (window.AOS) AOS.refreshHard()
  }

  function scrollStackedGalleryToVariant(productRoot, variant) {
    if (!productRoot || !variant || !variant.featured_media) return
    var thumb = productRoot.querySelector(
      '.product__thumb[data-id="' + String(variant.featured_media.id) + '"]'
    )
    if (!thumb) return
    var idx = thumb.getAttribute("data-index")
    if (idx === null) return
    var slide = productRoot.querySelector('.product-main-slide[data-index="' + idx + '"]')
    if (slide && typeof slide.scrollIntoView === "function") {
      slide.scrollIntoView({ behavior: "smooth", block: "nearest" })
    }
  }

  function primeComplementaryMediaEntrance(drawerEl) {
    if (!drawerEl) return
    var mq = window.matchMedia("(min-width: 769px)")
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)")
    if (!mq.matches || reduce.matches) return
    drawerEl.classList.add(PANELS_PRIME_CLASS)
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        drawerEl.classList.remove(PANELS_PRIME_CLASS)
      })
    })
  }

  function bindComplementaryCloseButtonsCapture(drawerEl, ctl) {
    if (!drawerEl || !ctl) return
    drawerEl.querySelectorAll(".js-drawer-close").forEach(function (btn) {
      if (btn.dataset.complementaryCloseCapture === "1") return
      btn.dataset.complementaryCloseCapture = "1"
      btn.addEventListener(
        "click",
        function (e) {
          e.preventDefault()
          e.stopImmediatePropagation()
          if (ctl.isOpen && typeof ctl.close === "function") ctl.close()
        },
        true
      )
    })
  }

  function setupComplementaryDesktopStack(contentEl) {
    var mq = window.matchMedia("(min-width: 769px)")
    var productRoot = contentEl.querySelector(".complementary-drawer-product[data-section-id]")
    if (!productRoot || !window.theme || !theme.sections) return

    function apply() {
      var sid = productRoot.getAttribute("data-section-id")
      var inst = typeof theme.sections._findInstance === "function" ? theme.sections._findInstance(sid) : null
      if (!inst || !inst.cache || !inst.cache.mainSlider) return

      if (!mq.matches) {
        productRoot.classList.remove("complementary-drawer-product--stacked-desktop")
        if (!inst.flickity && typeof inst.initProductSlider === "function") {
          inst.initProductSlider()
        }
        return
      }

      productRoot.classList.add("complementary-drawer-product--stacked-desktop")
      if (inst.flickity && typeof inst.flickity.destroy === "function") {
        inst.flickity.destroy()
      }
      inst.flickity = null
    }

    apply()
    if (typeof mq.addEventListener === "function") {
      mq.addEventListener("change", apply)
    } else if (typeof mq.addListener === "function") {
      mq.addListener(apply)
    }

    if (productRoot.dataset.complementaryVariantScroll === "1") return
    productRoot.dataset.complementaryVariantScroll = "1"
    productRoot.addEventListener("variantImageChange", function (e) {
      if (!mq.matches || !productRoot.classList.contains("complementary-drawer-product--stacked-desktop")) return
      var variant = e.detail && e.detail.variant
      scrollStackedGalleryToVariant(productRoot, variant)
    })
  }

  function openDrawer(triggerEl) {
    var ctl = getDrawerController()
    if (!ctl || !ctl.drawer) return
    if (!ctl.isOpen) {
      ctl.open(null, triggerEl)
    } else if (triggerEl) {
      triggerEl.setAttribute("aria-expanded", "true")
      ctl.activeSource = triggerEl
    }
  }

  function loadProduct(handle, prEl, triggerBtn) {
    var content = document.getElementById(CONTENT_ID)
    var drawerEl = document.getElementById(DRAWER_ID)
    if (!content || !drawerEl) return

    fetchLoadGen++
    var myFetch = fetchLoadGen

    var heading = (prEl && prEl.getAttribute("data-complementary-drawer-heading")) || ""
    var showDesc = prEl && prEl.getAttribute("data-complementary-show-description")

    drawerEl.classList.remove("complementary-drawer--has-content")
    drawerEl.classList.remove(CLOSING_PANELS_CLASS)
    drawerEl.classList.remove(PANELS_PRIME_CLASS)
    drawerEl.removeAttribute(STAGED_CLOSE_ATTR)

    removeProductInstance(content)
    content.classList.add(LOADING_CLASS)
    content.innerHTML =
      '<div class="complementary-drawer__loading" aria-live="polite"><span class="complementary-drawer__spinner"></span></div>'

    openDrawer(triggerBtn)

    fetch(buildFetchUrl(handle))
      .then(function (r) {
        if (myFetch !== fetchLoadGen) return null
        if (!r || !r.ok) throw new Error("complementary_fetch_failed")
        return r.text()
      })
      .then(function (html) {
        if (myFetch !== fetchLoadGen) return
        if (html === null || typeof html !== "string") return

        var doc = new DOMParser().parseFromString(html, "text/html")
        var productRoot =
          doc.querySelector('[data-section-type="product"]') || doc.querySelector(".complementary-drawer-product")

        if (!productRoot) {
          showComplementaryLoadError(content)
          return
        }

        content.classList.remove(LOADING_CLASS)
        content.innerHTML = ""

        if (myFetch !== fetchLoadGen) return

        content.appendChild(document.importNode(productRoot, true))
        drawerEl.classList.add("complementary-drawer--has-content")
        primeComplementaryMediaEntrance(drawerEl)
        if (heading) setDrawerTitle(heading)
        applyDescriptionVisibility(showDesc)
        initInjectedProduct(content)
        setupComplementaryDesktopStack(content)
        var ctlAfter = getDrawerController()
        if (ctlAfter) bindComplementaryCloseButtonsCapture(drawerEl, ctlAfter)
      })
      .catch(function () {
        if (myFetch !== fetchLoadGen) return
        showComplementaryLoadError(content)
      })
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (!document.getElementById(DRAWER_ID)) return
    if (!window.theme || typeof theme.Drawers !== "function") return

    var ctl = new theme.Drawers(DRAWER_ID, "complementary-product")
    if (!ctl.drawer) return
    theme._complementaryDrawerCtl = ctl

    var closeOrig = ctl.close.bind(ctl)
    installStagedClose(ctl, closeOrig)

    var drawerNode = document.getElementById(DRAWER_ID)
    bindComplementaryBackdrop(drawerNode, ctl)
    bindComplementaryCloseButtonsCapture(drawerNode, ctl)
    bindComplementaryAjaxCloseThenCart()

    document.addEventListener("click", function (e) {
      var btn = e.target.closest(".js-complementary-quick-view")
      if (!btn) return
      e.preventDefault()
      e.stopPropagation()
      var handle = btn.getAttribute("data-product-handle")
      if (!handle) return
      var pr = btn.closest("product-recommendations[data-intent=complementary]")
      loadProduct(handle, pr, btn)
    })
  })
})()
